import React from "react";
import { Skeleton } from '@mui/material';

function EASkeleton(props) {
    return (
        <Skeleton
            variant="rectangular"
            height={props.height}
            animation="wave"
        />
    );
}

export default EASkeleton;